export var getAvatarDetails = function (user, avatarColors) {
    var colors = avatarColors || ['#747474', '#339AA5', '#B66AD6', '#FF3A67', '#519D2F', '#E3620B', '#7083E7'];
    var name = (user.firstName ? "".concat(user.firstName, " ").concat(user.lastName) : user.name ? user.name : user.userName).trim();
    var sum = 0;
    for (var i = 0; i < name.length; i++) {
        sum += name.charCodeAt(i);
    }
    var avatarColor = colors[sum % colors.length];
    var shortName = user.userName[0].toUpperCase();
    // name.split(' ').forEach((word: string, index: number) => {
    //     if (index !== 0) {
    //         shortName += ' ';
    //     }
    //     shortName += word[0];
    // })
    // shortName = (shortName || "").toUpperCase();
    var userName = user.userName;
    var nameWithUserName = "".concat(name, " (").concat(userName, ")");
    return { name: name, userName: userName, nameWithUserName: nameWithUserName, avatarColor: avatarColor, shortName: shortName };
};
//# sourceMappingURL=avatar.js.map